"use client";

import { useEffect, useState } from "react";
import MobileSkeleton from "./MobileSkeleton";
import DesktopSkeleton from "./DesktopSkeleton";

const ResponsiveFeaturedSkeleton = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check screen size
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return isMobile ? <MobileSkeleton /> : <DesktopSkeleton />;
};

export default ResponsiveFeaturedSkeleton;
